import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import router from "../router/index";
import { Toast } from "vant";
axios.defaults.withCredentials = false;
Vue.use(VueAxios, axios);
let baseurl =
  process.env.NODE_ENV === "production"
    ? "https://train-service-api.procaregroup.com"
    : "/back";
console.log(baseurl);
// let imageUrl =
//   process.env.NODE_ENV === "production"
//     ? "https://train-service-cdn.oss-cn-shenzhen.aliyuncs.com/"
//     : "https://gymoo-project-cdn.oss-cn-shenzhen.aliyuncs.com/";

let imageUrl =
  process.env.NODE_ENV === "production"
    ? "https://train-service-cdn.oss-cn-shenzhen.aliyuncs.com/"
    : "https://train-service-cdn.oss-cn-shenzhen.aliyuncs.com/";

export let imgUrl = imageUrl;
export const upload_url =
  process.env.NODE_ENV === "production"
    ? "https://train-service-api.procaregroup.com/v1/common/UploadFile"
    : "https://train-service-api.gymooit.cn/public/upload";
export let apiCollection = Vue.axios.create({
  method: "GET",
  baseURL: baseurl,
});

export let apiResource = Vue.axios.create({
  method: "POST",
  baseURL: baseurl,
});
export let apiFormSubmit = Vue.axios.create({
  method: "POST",
  baseURL: baseurl,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});
export let apiPut = Vue.axios.create({
  method: "PUT",
  baseURL: baseurl,
});
export let apiDelete = Vue.axios.create({
  method: "DELETE",
  baseURL: baseurl,
});
let loading;
function startLoading() {
  loading = Toast.loading({
    message: "加载中...",
    forbidClick: true,
    duration: 0,
  });
}

function endLoading() {
  loading.clear();
}
const axiosInstace = [
  apiCollection,
  apiResource,
  apiFormSubmit,
  apiDelete,
  apiPut,
];
const value = localStorage.getItem("X-Access-Token");
axiosInstace.forEach((item) => {
  startLoading();
  item.defaults.headers["X-Access-Token"] = value;
  item.defaults.withCredentials = false;
  item.interceptors.response.use(
    (response) => {
      endLoading();
      return response.data;
    },
    (error) => {
      if (error.response.status == 401) {
        console.log(error.response.status);
        router.replace({ path: "/mb_login" });
        // Message.warning ('请到个人中心页面登录！');
        // localStorage.removeItem ('X-Access-Token');
      }
      if (error && error.response) {
        endLoading();
        console.log(error.response);
        Toast({
          message: error.response.data.error.message,
          duration: 5000,
        });
        return error.response.data;
        // router.push ('/error');
      }
    }
  );
  endLoading();
});



// WEBPACK FOOTER //
// ./src/util/request.js